import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue';
import { ICommandBase } from '@Quest/cqrs';
import PortfolioScenariosCommands from '@Quest/PortfolioScenarios/Domain/commands-vue-component';
import PortfolioScenariosQueries from '@Quest/PortfolioScenarios/Domain/queries-vue-component';
import { ResourceConstraintPageReadModel } from '@Quest/PortfolioScenarios/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';


@Component({ components: { PortfolioNavigation } })
export default class ResourceConstraintPage extends mixins(PortfolioScenariosQueries, PortfolioScenariosCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get tchProjectId(): number { return Number.parseInt(this.$route.params.tchProjectId); }
    get scenarioId() { return this.$route.params.scenarioId; }
    get resourceId() { return this.$route.params.resourceId; }

    rm: ResourceConstraintPageReadModel | null = null;


    mounted()
    {
        document.title = "Portfolio Plan - Resource";
        this.runResourceConstraintPageQueryV1(this.workspaceId, this.tchProjectId, this.scenarioId, this.resourceId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "ResourceConstraintPageReadModel")
        {
            this.rm = model as ResourceConstraintPageReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {

    }
}